import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Typography, Button, Paper, Grid, CircularProgress, Box, Alert } from '@mui/material';
import { Edit as EditIcon, Delete as DeleteIcon } from '@mui/icons-material';
import { obterEstudante, excluirEstudante } from '../../services/estudanteService';
import PageHeader from '../../components/Common/PageHeader';

const DetalhesEstudantePage = () => {
  const [estudante, setEstudante] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    obterEstudante(id)
      .then(setEstudante)
      .catch(() => setError('Não foi possível carregar os dados do estudante.'))
      .finally(() => setLoading(false));
  }, [id]);

  const handleExcluir = async () => {
    if (window.confirm('Tem certeza que deseja excluir este estudante?')) {
      try {
        await excluirEstudante(id);
        navigate('/estudantes');
      } catch {
        setError('Erro ao excluir estudante.');
      }
    }
  };

  if (loading) {
    return <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}><CircularProgress /></Box>;
  }

  if (error) {
    return <Box sx={{ p: 3 }}><Alert severity="error">{error}</Alert></Box>;
  }

  if (!estudante) return null;

  return (
    <Box sx={{ p: 3 }}>
      <PageHeader
        title={estudante.nome}
        subtitle="Detalhes do estudante"
        backTo="/estudantes"
        breadcrumbs={[{ label: 'Estudantes', to: '/estudantes' }, { label: estudante.nome }]}
        actions={
          <>
            <Button
              variant="outlined"
              startIcon={<EditIcon />}
              onClick={() => navigate(`/estudantes/editar/${id}`)}
            >
              Editar
            </Button>
            <Button
              variant="outlined"
              color="error"
              startIcon={<DeleteIcon />}
              onClick={handleExcluir}
            >
              Excluir
            </Button>
          </>
        }
      />
      <Paper sx={{ p: 3, borderRadius: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Typography><strong>Email:</strong> {estudante.email}</Typography>
            <Typography><strong>Telefone:</strong> {estudante.telefone}</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography>
              <strong>Data de Nascimento:</strong>{' '}
              {estudante.dataNascimento ? new Date(estudante.dataNascimento).toLocaleDateString('pt-MZ') : '—'}
            </Typography>
            <Typography><strong>Género:</strong> {estudante.genero}</Typography>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default DetalhesEstudantePage;
